module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer footer-small footer-color-black",
    attrs: {
      "data-color": "black"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendUserMessage($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactUs.email),
      expression: "contactUs.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.email),
      expression: "rules.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "placeholder": "user@ezifood.com"
    },
    domProps: {
      "value": (_vm.contactUs.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactUs.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('email')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('phone')
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactUs.phone),
      expression: "contactUs.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.phone),
      expression: "rules.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phone",
      "name": "phone",
      "placeholder": "0241000111"
    },
    domProps: {
      "value": (_vm.contactUs.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactUs.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('phone')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('message')
    }
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactUs.message),
      expression: "contactUs.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.message),
      expression: "rules.message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "message",
      "name": "message",
      "placeholder": "Ezifood is the best"
    },
    domProps: {
      "value": (_vm.contactUs.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactUs.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('message')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('message')))])], 1), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n            © " + _vm._s(_vm.currentYear) + " - Ezifood - A product of Ezitek Solutions\n        ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("About")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("Ezifood is a product of Ezitek Solutions. It is a web and mobile application that allows you to order food from your favourite restaurants in simple and easy steps.")]), _vm._v(" "), _c('h2', {
    staticClass: "text-center large-margin-top"
  }, [_vm._v("Get In Touch")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "info-mail-link",
      "href": "mailto:info@ezifood.com"
    }
  }, [_vm._v("info@ezifood.com")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone:")]), _vm._v(" 054 204 3151")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Location:")]), _vm._v(" KNUST - Kumasi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center margin-top-bottom"
  }, [_c('button', {
    staticClass: "btn btn-default btn-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Contact Us")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56b42a1e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Footer.vue
// module id = 210
// module chunks = 14